export default "__VITE_ASSET__CQKhIUsn__"